import {getFeaturesUnionByReferences} from '@apps-common/geocorn-sdk/api/features';

export const hydrateSearchGeometry = async search => {
  if (search.geometry?.type === 'ref') {
    const hydratedGeo = await getFeaturesUnionByReferences(
      search.geometry.content
    );
    let featureRef;
    if (
      Array.isArray(search.geometry.content) &&
      search.geometry.content.length === 1
    ) {
      featureRef = search.geometry.content[0];
    } else {
      featureRef = search.geometry.content;
    }

    return {
      ...search,
      hydratedGeometry: hydratedGeo.geometry,
      featureReference: featureRef,
    };
  } else if (search.geometry) {
    return {
      ...search,
      hydratedGeometry: search.geometry,
    };
  } else {
    return search;
  }
};
